module.exports = __webpack_public_path__ + "static/media/swipe-helper.603bb285.gif";